/* eslint-disable react/no-array-index-key */
import React, { Component } from "react";
import { Checkbox } from "antd";
import FilesUpload from "nbugs-files-upload";

import styles from "./index.less";
import { ENV } from "@/services/utils";

class EvaluateList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderList = () => {
    const { list, reRender } = this.props;
    return (
      <div>
        {list.map((item, index) => {
          const {
            name,
            score,
            remark,
            wetherRealPatrol,
            appendix,
            reportUser
          } = item;
          return (
            <div className="detail-wrap" key={`evaluate-${name}-${index}`}>
              <div className="detail-item">
                <div className="item-title">评估分数</div>
                <div className="content">{score}分</div>
              </div>
              <div className="detail-item">
                <div className="item-title">评估说明</div>
                <div className="content">{remark}</div>
              </div>
              <div className="detail-item">
                <div className="item-title">评估人</div>
                <div className="content">{reportUser}</div>
              </div>
              <div className="detail-item">
                <div className="item-title">考评模版</div>
                <div className="content">
                  {reRender && (
                    <FilesUpload
                      edit={1}
                      type="pc"
                      APIEnv={ENV}
                      groupId={appendix}
                      previewUrl={`//${window.location.hostname}/v2/preview/file`}
                    />
                  )}
                </div>
              </div>
              <div className="detail-item">
                <div className="item-title" />
                <div className="content">
                  <Checkbox checked={!!wetherRealPatrol}>
                    已加入实地核查计划
                  </Checkbox>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    return (
      <div className={styles.evaluateList}>
        <div className="detail-title">评估情况</div>
        {this.renderList()}
      </div>
    );
  }
}

export default EvaluateList;
